module.exports = __webpack_public_path__ + "7705a92fcf6aac40eae920b161d5470c.png";